// extracted by mini-css-extract-plugin
module.exports = {"scrolldown":"scrolldown-module--scrolldown--36rYp","icon":"scrolldown-module--icon--1UmHy"};